var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.subtitle))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col",domProps:{"innerHTML":_vm._s(_vm.main)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }